import { useFavorites, IconButton} from '@tunasong/ui-lib'
import { Header } from '../header.js'
import { Link as RouterLink } from 'react-router'
import { Favorite, FavoriteBorder, Home, type IconName } from '@tunasong/icons'
import type { HTMLAttributes } from 'react'

export interface PageHeaderProps extends HTMLAttributes<HTMLDivElement> {
  name?: string
  pageIconName?: IconName
  ref?: React.Ref<HTMLDivElement>
  showBackButton?: boolean
}

export const PageHeader = (props: PageHeaderProps) => {
  const { name, ref, showBackButton = true, pageIconName, ...restProps } = props
  const { currentFavorite, addFavorite, removeFavorite } = useFavorites()

  const linkStyle = {
    display: 'flex',
    alignItems: 'center',
    marginRight: 8,
    fontWeight: 300,
    textDecoration: 'none',
    cursor: 'pointer',
    color: 'inherit',
  }

  return (
    <Header
      ref={ref}
      position="absolute"
      elevation={0}
      controls={[
        name ? (
          <IconButton
            key={0}
            color={currentFavorite ? 'error' : 'inherit'}
            onClick={ev => {
              ev.preventDefault()
              ev.stopPropagation()
              if (currentFavorite) {
                removeFavorite(currentFavorite)
              } else {
                addFavorite({ name, iconName: pageIconName })
              }
            }}
            aria-label={currentFavorite ? 'Remove from favorites' : 'Add to favorites'}
          >
            {currentFavorite ? <Favorite /> : <FavoriteBorder />}
          </IconButton>
        ) : null,
      ].filter(Boolean)}
      showBackButton={showBackButton}
      breadcrumbs={
        <nav aria-label="breadcrumb" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <RouterLink
            style={{
              ...linkStyle,
              marginRight: 0,
              color: 'var(--tuna-palette-action-disabled)',
            }}
            to="/app"
            title="Home link"
            aria-label="Home link"
          >
            <Home size={24} style={{ marginRight: 0 }} />
          </RouterLink>
          {name ? (
            <span style={{ color: 'var(--tuna-palette-text-secondary)' }}>/</span>
          ) : null}
          {name ? (
            <RouterLink style={{ ...linkStyle, fontSize: 14 }} to={`.`} title={name}>
              {name}
            </RouterLink>
          ) : null}
        </nav>
      }
      {...restProps}
    />
  )
}
